// @flow
import styled from "styled-components";
import { renderRoutes } from "react-router-config";
import { PreviewMode } from "../Page/PreviewMode";
import { ErrorBoundary } from "../../components/Blog/ErrorBoundary";

export const BlogWrapper = styled.div`
  padding-top: 40px;
  border-top: ${({ theme }) => `1px solid ${theme.palette.hague10}`};
`;

type Props = RouteProps<{}>;

export const Blog = ({ route: { routes } }: Props) => (
  <div>
    <ErrorBoundary>
      <PreviewMode />
      {renderRoutes(routes)}
    </ErrorBoundary>
  </div>
);

export const UniversalRender = Blog;
